import React, { Component } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import UserNav from "../UserDashboard/UserNav";

function getQueryParam(search, key) {
  return new URLSearchParams(search).get(key);
}

class CheckoutSuccess extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      payment: null,
      error: null
    };
  }

  componentDidMount() {
    localStorage.removeItem("pendingStripeCheckout");

    const sessionId = getQueryParam(this.props.location.search, "session_id");

    if (!sessionId) {
      this.setState({
        loading: false,
        error: "Checkout completed, but no Stripe session ID was returned."
      });
      return;
    }

    axios
      .get("/api/stripe/checkout-session/" + sessionId)
      .then(res => {
        this.setState({
          loading: false,
          payment: res.data
        });
      })
      .catch(err => {
        this.setState({
          loading: false,
          error:
            err.response && err.response.data && err.response.data.message
              ? err.response.data.message
              : err.message
        });
      });
  }

  renderPaymentDetails() {
    const { payment } = this.state;

    if (!payment) {
      return null;
    }

    return (
      <div className="checkout-summary">
        <div>
          <span>Payment status</span>
          <strong>{payment.paymentStatus || "pending"}</strong>
        </div>
        <div>
          <span>Fulfillment</span>
          <strong>{payment.fulfillmentStatus || "pending"}</strong>
        </div>
        <div>
          <span>Purchase</span>
          <strong>{payment.purchaseType}</strong>
        </div>
      </div>
    );
  }

  render() {
    const { loading, error, payment } = this.state;

    return (
      <div>
        <UserNav />
        <div className="wrapper-alt">
          <div className="container checkout-result">
            <h1>Checkout complete</h1>
            {loading ? (
              <p>Confirming your checkout session...</p>
            ) : error ? (
              <div className="alert alert-warning">{error}</div>
            ) : (
              <p>
                Your payment was received. Access will appear in your dashboard
                as soon as Stripe finishes fulfillment.
              </p>
            )}

            {this.renderPaymentDetails()}

            <div className="checkout-actions">
              <Link className="btn btn-pp" to="/dashboard">
                Dashboard
              </Link>
              {payment && payment.purchaseType === "course" ? (
                <Link className="btn btn-secondary" to="/dashboard/courses">
                  Courses
                </Link>
              ) : null}
              {payment && payment.purchaseType === "subscription" ? (
                <Link
                  className="btn btn-secondary"
                  to="/dashboard/subscriptions"
                >
                  Subscriptions
                </Link>
              ) : null}
              {payment && payment.purchaseType === "pas" ? (
                <Link
                  className="btn btn-secondary"
                  to="/dashboard/planning-and-scanning"
                >
                  Planning and Scanning
                </Link>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CheckoutSuccess;
